<template lang='pug'>
.space-form.easy-scroll(:class='form.className || ""')
	.top-bar(:class='{ "move-left" : moveLeft }' ref='topBar')
		.title {{ form.title }}
		.icon-close(@click='cancel')

	.form-body
		layout(
			v-for='( section, index ) in form.layout'
			:key='index'
			:layout='section'
			:fields='form.fields'
			:form-inputs='form.components'
			:errors='errors'
			:form='form'
			:last-tab-index='lastTabIndex'

			:starting-data='initialData'

			@input='v => combineValues( v, "value" )'
			@data='v => combineValues( v, "data" )'
			@set-tab-index='setTabIndex'

			:value='value'
		)

		.submit-area
			.button.highlight-background(@click='submit' :class='{ error : hasError }') {{ buttonText }}
			p.error-text(v-if='hasErrors') Some Fields Were Not Filled Out Properly, Please Scroll Back Up
			p {{ buttonCaption }}
</template>

<script>
import Layout from '@/components/form-inputs/Layout';

// eslint-disable-next-line no-unused-vars
import { clone, combine, HasProperty } from '@/lib/utils';
import { validate } from '@/lib/Valid';

export default {
	name : 'space-form',

	props : {
		form : {
			required : true,
		},
	},

	data : () => ( {
		value  : {},
		errors : {},
		data   : {},

		initialData : {},

		moveLeft : false,

		submitListener : null,
		hasError       : false,

		lastTabIndex : 0,
	} ),

	created() {
		this.initialData = clone( this.form.startingData );
		this.value       = clone( this.form.startingData );
	},

	computed : {

		buttonText() {
			if ( HasProperty( this.form, 'buttonText' ) ) {
				return this.form.buttonText;
			}

			return 'Submit';
		},

		buttonCaption() {
			if ( HasProperty( this.form, 'buttonCaption' ) ) {
				return this.form.buttonCaption;
			}

			return '';
		},

		hasErrors() {
			return ( Object.keys( this.errors ).length > 0 );
		},

	},

	mounted() {
		const { topBar } = this.$refs;
		const { left }   = topBar.getBoundingClientRect();

		if ( left < 0 ) {
			this.moveLeft = true;
		}
	},

	methods : {

		setTabIndex() {
			this.lastTabIndex += 1;
		},

		combineValues( value, prop = 'value' ) {
			if ( !value ) {
				return;
			}

			const val = clone( this[prop] );

			Object.keys( value ).forEach( ( key ) => {
				val[key] = value[key];
			} );

			this[prop] = val;
		},

		cancel() {
			this.$emit( 'cancel' );
		},

		submit() {

			this.validate()
				.then( () => {
					this.valid = true;
					this.form.resolve( this.value );
				} )
				.catch( ( errors ) => {
					this.errors   = errors;
					this.hasError = true;
				} );
		},

		validate() {
			this.errors = {};

			return new Promise( ( resolve, reject ) => {

				this.$nextTick( () => {
					const validation = validate( this.value, this.form.fields );

					if ( typeof validation === 'object' && Object.keys( validation ).length ) {
						reject( validation );

						return;
					}

					resolve( validation );
				} );
			} );
		},

	},

	components : {
		Layout,
	}
};
</script>

<style lang='scss'>
@import '../assets/scss/variables';

.space-form {
	height: 100vh;
	width: 100%;
	overflow: auto;
	background: white;
	padding-bottom: 40px;
	box-shadow: $defaultBoxShadow;

	&.highlight {
		position: relative;

		&::before {
			content: '';
			position: absolute;
			top: 0;
			left: 0;
			transform: translate(-50%, -50%);
			width: 100px;
			height: 100px;
			border-radius: 50%;
		}
	}

	&.center-align {

		.form-body {

			.title,
			.sub-title {
				text-align: center;
			}
		}
	}

	.top-bar {
		display: flex;
		padding: 30px 19px 30px 30px;
		align-items: center;
		justify-content: space-between;
		width: 100%;

		&.move-left {
			left: 100vw;
		}

		&::before {
			content: ' ';
			height: 72px;
			width: 100%;
			position: absolute;
			top: 0;
			left: 0;
			background: $gradualDarkGreyToTop;
			transform: rotate(180deg);
			z-index: 1;
			pointer-events: none;
		}

		h1,
		.submit {
			z-index: 2;
		}

		.title {
			text-transform: uppercase;
			font-weight: 600;
			letter-spacing: 2px;
			color: $color-secondary;
			padding-left: 20px;
		}

		.title,
		.icon-close {
			z-index: 2;
		}
	}

	.form-body {
		margin-top: 30px;
	}

	.layout + .layout {
		margin-top: 30px;
	}

	.submit-area {
		position: relative;
		margin-top: 30px;

		&::before {
			content: ' ';
			position: absolute;
			top: 50%;
			left: 0;
			width: 100%;
			z-index: 0;
			height: 50px;
			background: $gradientOne;
		}

		.button {
			position: relative;
			left: 50%;
			transform: translateX(-50%);
			width: fit-content;
			padding: 10px 35px;

			&.error {
				color: white;
				background: $error !important;
			}
		}

		p {
			position: absolute;
			z-index: 2;
			font-size: 16px;
			width: 80%;
			left: 50%;
			transform: translateX(-50%);
			top: 100%;

			&.error-text {
				color: $error!important;
				text-align: center;
				margin: 30px 0!important;
				letter-spacing: 2px;
				width: 60%;
				font-size: 14px;
			}
		}
	}
}

@media( max-width: $tablet ) {

	.space-form .submit .button.no-bg {
		display: none;
	}
}
</style>
